var _path, _circle, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 5.99878H9.5C9.23478 5.99878 8.98043 6.10414 8.79289 6.29167C8.60536 6.47921 8.5 6.73356 8.5 6.99878V24.9988C8.5 25.264 8.60536 25.5184 8.79289 25.7059C8.98043 25.8934 9.23478 25.9988 9.5 25.9988H21.5C21.7652 25.9988 22.0196 25.8934 22.2071 25.7059C22.3946 25.5184 22.5 25.264 22.5 24.9988V6.99878C22.5 6.73356 22.3946 6.47921 22.2071 6.29167C22.0196 6.10414 21.7652 5.99878 21.5 5.99878ZM10.5 23.9988V7.99878H20.5V23.9988H10.5Z",
    fill: "#24A3D2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 21.9988,
    r: 1,
    fill: "#24A3D2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 8.99878,
    width: 8,
    height: 11,
    rx: 1,
    fill: "#24A3D2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/Online.66731548b355d297ad86854cc67085f6.svg";
export { ForwardRef as ReactComponent };